import { useState } from "react";
import { track, useSiteConfig } from "../lib/site";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import MessageForm from "./MessageForm";

// The single site-wide action. With a live Acuity link: "Book a session" opens
// Dorothy's hosted scheduler. Without it: "Schedule an appointment" opens the
// inquiry pop-up (name, number, comments) straight to Dorothy's inbox.
export function useBooking() {
  const config = useSiteConfig();
  const url = config.scheduler?.url || "";
  const live = Boolean(config.scheduler?.configured && url);
  return { live, url, label: live ? "Book a session" : "Schedule an appointment" };
}

export default function BookingCta({ location, testid, className = "btn-primary", children }) {
  const { live, url, label } = useBooking();
  const [open, setOpen] = useState(false);

  if (live) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        onClick={() => track("booking_click", { location })}
        className={className}
      >
        {children || label}
      </a>
    );
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          onClick={() => track("appointment_cta_click", { location })}
          className={className}
        >
          {children || label}
        </button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] overflow-y-auto bg-background sm:max-w-lg" data-testid="schedule-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-3xl font-semibold text-primary">Schedule an appointment</DialogTitle>
          <DialogDescription className="text-base">
            Leave your details and Dorothy will reply personally, in her own time.
          </DialogDescription>
        </DialogHeader>
        <MessageForm />
      </DialogContent>
    </Dialog>
  );
}
